import { extendTheme, type ThemeConfig } from '@chakra-ui/react';

const config: ThemeConfig = {
  initialColorMode: 'light',
  useSystemColorMode: false,
};

const theme = extendTheme({
  config,
  colors: {
    deebits: {
      red: '#E31837',
      gray: '#666666',
      black: '#000000',
    },
    canadian: {
      red: '#E31837',
      white: '#FFFFFF',
      50: '#FFF5F5',
      100: '#FED7D7',
      200: '#FEB2B2',
      300: '#FC8181',
      400: '#F56565',
      500: '#E53E3E',
      600: '#C53030',
      700: '#9B2C2C',
      800: '#822727',
      900: '#63171B',
    },
  },
  fonts: {
    heading: '"Helvetica Neue", sans-serif',
    body: 'system-ui, sans-serif',
  },
  styles: {
    global: {
      body: {
        bg: 'gray.50',
      },
    },
  },
  components: {
    Button: {
      baseStyle: {
        fontWeight: 'bold',
      },
      variants: {
        solid: {
          bg: 'deebits.red',
          color: 'white',
          _hover: {
            bg: 'canadian.600',
          },
        },
      },
    },
  },
});

export default theme; 